export const HINTS_COUNT = 3;
export const CELL_TYPE = {
    DEFAULT: 0,
    SET: 1,
    HINT: 2
};
export const SAVING_INTERVAL = 5000;
export const SESSION_STORAGE_KEY = 'rysudoku';
export const MARK_INVALID = false;
